import React, { useState } from 'react';
import { Img } from "Components/Img";
import { getGenderAvatar } from "helpers/string";
import { formatImgUrl } from "utils/helpers";
import { DEFAULT_USER_AVATAR_IMG } from "Assets/images";

type Props = {
  data: {
    user_image?: string;
    salutation?: string;
  };
};

const UserAvatar = ({ data }: Props) => {
  const { user_image, salutation = "" } = data;
  const [imgSrc, setImgSrc] = useState(() => {
    if (user_image) {
      return formatImgUrl(user_image);
    } else if (salutation) {
      return getGenderAvatar(salutation) || DEFAULT_USER_AVATAR_IMG;
    }
    return DEFAULT_USER_AVATAR_IMG;
  });

  const handleError = () => {
    setImgSrc(DEFAULT_USER_AVATAR_IMG);
  };

  return (
    <Img
      src={imgSrc}
      className="avatar"
      width={40}
      height={40}
      onError={handleError}
    />
  );
};

export default UserAvatar;
